<!-- 自营司机代垫统计表 -->
<template>
  <div>
    <div :style="{ opacity: config.isConfigMode ? 0.5 : 1, pointerEvents: config.isConfigMode ? 'none' : 'auto' }">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="司机姓名">
          <el-input v-model="dataForm.driverName" placeholder="支持模糊查询" clearable></el-input>
        </el-form-item>
        <el-form-item label="月份" prop="takeGoodsDate">
          <el-date-picker
              v-model="dataForm.takeGoodsDate"
              type="month"
              placeholder="选择日期"
              value-format="yyyy-MM"
              :clearable="false"
              :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="推送状态" prop="pushNotification">
          <el-select class="item-choose" v-model="dataForm.pushNotification" style="width: 100%;" filterable clearable placeholder="请选择">
            <el-option label="待推送" value="0"></el-option>
            <el-option label="已推送" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="确认状态" prop="confirmStatus">
          <el-select class="item-choose" v-model="dataForm.confirmStatus" style="width: 100%;" filterable clearable placeholder="请选择">
            <el-option label="待确认" value="0"></el-option>
            <el-option label="已确认" value="1"></el-option>
            <el-option label="异常反馈" value="2"></el-option>
            <el-option label="驳回" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: right; display: flex; justify-content: flex-end; align-items: center;">
          <el-button @click="getDataList(1)" type="primary">查询</el-button>
          <el-button @click="downLoad()" type="success">导出</el-button>
          <el-button @click="pushTheMonthlySalarySlip()" type="info" :disabled="pushTheMonthlySalarySlipDisabled || dataForm.takeGoodsDate == undefined || dataListSelections.length == 0">推送当前选择月份工资条</el-button>
          <el-button @click="smallProgramPageConfiguration()" type="warning">小程序页面配置</el-button>
          <el-button size="small" @click="templateConfigurationMode(0)" type="warning">模板配置模式</el-button>
        </el-form-item>
      </el-form>
    </div>


    <div class="tableBox" :style="{ position: 'relative' }">
      <!-- 配置模式 -->
      <el-row v-if="config.isConfigMode" style="justify-self: center;padding: 10px 10px">
        <el-button size="mini" @click="config.isConfigMode = false" type="danger">取消配置模式</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(1)" type="success">保存模板</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(2)" type="warning">修改模板</el-button>
        <el-button v-no-more-click size="mini" @click="$refs.configTableRef.init(config.configTableId)" type="warning">所有模板</el-button>
        <el-popover placement="right" width="520" trigger="click">
          <div style="justify-self: center;">
            <el-button v-no-more-click @click="checkAllNodes(true)" size="mini">全选</el-button>
            <el-button v-no-more-click @click="checkAllNodes(false)" size="mini">全不选</el-button>
            <el-tooltip class="item" effect="dark" content="可拖拽必须先取消固定才允许拖拽排列,如果有固定固定按钮会显示为绿色" placement="top-start">
              <i class="el-icon-view el-icon--right" />
            </el-tooltip>
          </div>
          <br/>
          <el-tree :data="config.configDefaultColumn"
                   style="max-height: 200px;overflow-y: auto;"
                   default-expand-all
                   show-checkbox
                   draggable
                   node-key="prop"
                   ref="configTableListTree"
                   @check-change="handleCheckChange"
                   @node-drop="handleDrop"
                   :allow-drag="allowDrag"
                   :allow-drop="allowDrop">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <el-row :gutter="20">
                       <el-col :span="16">
                         <div class="grid-content bg-purple">
                           <el-input size="mini" placeholder="列头名" v-model="data.label" @change="refreshTableV(config.configDefaultColumn)"></el-input>
                         </div>
                       </el-col>
                       <el-col :span="8">
                         <div class="grid-content bg-purple">
                           <el-link :type="data.fixed && data.fixed === 'left' ? 'success' : 'info'" @click="data.fixed = 'left'" :underline="false" :disabled="data.parentLabel != undefined" >固定左侧</el-link>
                           <el-link :type="data.fixed && data.fixed === 'right' ? 'success' : 'info'" @click="data.fixed = 'right'" :underline="false" :disabled="data.parentLabel != undefined" >固定右侧</el-link>
                           <el-link :disabled="!data.fixed" :underline="false" @click="data.fixed = undefined" >取消固定</el-link>
                         </div>
                       </el-col>
                    </el-row>
                  </span>
          </el-tree>
          <el-button style="margin-left: 10px;" size="mini" slot="reference" icon="el-icon-s-tools" circle />
        </el-popover>
        <br/>
        <br/>
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-input v-model="config.configModeForm.name" size="mini" placeholder="模板名称" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple-light">
              <el-input v-model="config.configModeForm.remark" size="mini" placeholder="备注" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-switch
                  v-model="config.configModeForm.defaultOrNot"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="'1'"
                  :inactive-value="'0'">
              </el-switch>
            </div>
          </el-col>
        </el-row>
      </el-row>

      <el-table :data="dataList"
                :key="config.tableKey"
                ref="tableRef"
                @row-click="rowClick"
                :row-style="selectedHighlight"
                :cell-class-name="getCellClassName"
                show-summary
                :height="this.tableHeight"
                border
                size="small"
                v-loading="dataListLoading"
                @selection-change="handleSelectionChange"
                style="width: 100%;"
                :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" fixed="left" align="center" width="40" />

        <template v-for="(item, index) in config.configDefaultColumnTwo">
          <!-- 如果有子列，渲染子列 -->
          <template v-if="item.children && item.children.length">
            <el-table-column :label="item.label" align="center" :key="`group-${item.label}`" :class-name="item.styleClass" :class="item.styleClass">
              <el-table-column
                  v-for="(child, childIndex) in item.children"
                  :key="`children-${childIndex}`"
                  align="left"
                  :prop="child.prop"
                  :label="child.label"
                  :width="child.width"
                  :fixed="child.fixed"
                  v-if="child.check"
                  :class="child.styleClass"
                  :show-overflow-tooltip="true"
                  :class-name="child.styleClass">
                <template slot-scope="scope">
                  {{ getFormatter(child.formatter)(scope.row, child, _.get(scope.row, child.prop)) }}
                </template>
              </el-table-column>
            </el-table-column>
          </template>
          <!-- 如果没有子列，渲染普通列 -->
          <template v-else>
            <el-table-column
                :key="`single-${index}`"
                align="left"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
                :fixed="item.fixed"
                v-if="item.check"
                :class="item.styleClass"
                :show-overflow-tooltip="true"
                :class-name="item.styleClass">
              <template slot-scope="scope">
                <!-- 推送状态 -->
                <template v-if="item.prop == 'pushStatusStr'">
                  <el-tag v-if="scope.row.pushStatusStr === '未推送'" size="small" type="danger">未推送</el-tag>
                  <el-tag v-else size="small">已推送</el-tag>
                </template>
                <!-- 确认状态 -->
                <template v-else-if="item.prop == 'driverConfirmationStateStr'">
                  <el-tag v-if="scope.row.driverConfirmationStateStr === '待确认'" size="small" type="info">待确认</el-tag>
                  <el-tag v-if="scope.row.driverConfirmationStateStr === '已确认'" size="small">已确认</el-tag>
                  <el-tag v-if="scope.row.driverConfirmationStateStr === '异常反馈'" size="small" type="danger">异常反馈</el-tag>
                  <el-tag v-if="scope.row.driverConfirmationStateStr === '驳回'" size="small" type="danger">驳回</el-tag>
                </template>
                <!-- 签字图 -->
                <template v-else-if="item.prop == 'driverSignatureEditionUrl'">
                  <el-image v-if="scope.row.driverSignatureEditionUrl != null" style="width: 30px; height: 30px" fit="cover" :preview-src-list="[domain + scope.row.driverSignatureEditionUrl]" :src="domain + scope.row.driverSignatureEditionUrl" />
                </template>
                <template v-else>
                  {{ getFormatter(item.formatter)(scope.row, item, _.get(scope.row, item.prop)) }}
                </template>
              </template>
            </el-table-column>
          </template>
        </template>

        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="rejectMethod(scope.row)" :disabled="!(scope.row.driverConfirmationStateStr == '已确认')">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>

    <el-dialog :title="reject.title" :visible.sync="reject.visible">
      <el-form ref="form" :model="reject.data">
        <el-form-item label="驳回原因">
          <el-input type="textarea" autosize placeholder="请输入内容" v-model="reject.data.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reject.visible = false">取 消</el-button>
        <el-button type="primary" @click="rejectSuccess">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 模板配置弹窗 -->
    <configTable ref="configTableRef" />
  </div>
</template>

<script>
import configTable from '@/components/table'
import * as myJsonClon from "@/utils/myJsonClone";
export default {
  components: {configTable},
  data () {
    return {

      // -----------------动态表格模式start-----------------
      config: {
        tableKey: 0, // 用于强制刷新表格
        configId: null,
        configTableId: 55,
        configDefaultColumn: [
          {label: '司机姓名',prop: 'driverName',check: true,fixed: 'left'},
          {label: '年月',prop: 'yearMonth',check: true,fixed: 'left'},
          {label: '订单数',prop: 'orderNum',check: true,fixed: 'left',formatter: 'getNumValue'},
          {label: '推送状态',prop: 'pushStatusStr',check: true,fixed: undefined},
          {label: '确认状态',prop: 'driverConfirmationStateStr',check: true,fixed: undefined},
          {label: '签字图',prop: 'driverSignatureEditionUrl',check: true,fixed: undefined},
          {label: '异常反馈',prop: 'driverErrorRemark',check: true,fixed: undefined},
          {label: '驳回原因',prop: 'rejectionRemarks',check: true,fixed: undefined},
          {label: '代支过磅费',prop: 'weighFee',check: true,fixed: undefined,formatter: 'getNumValue',styleClass: 'yellow-cell',parentLabel: '成本支付(司机代支部分)'},
          {label: '代支装卸费',prop: 'loadFee',check: true,fixed: undefined,formatter: 'getNumValue',styleClass: 'yellow-cell',parentLabel: '成本支付(司机代支部分)'},
          {label: '代支入仓报关费',prop: 'entranceFee',check: true,fixed: undefined,formatter: 'getNumValue',styleClass: 'yellow-cell',parentLabel: '成本支付(司机代支部分)'},
          {label: '代支停车费',prop: 'parkingFee',check: true,fixed: undefined,formatter: 'getNumValue',styleClass: 'yellow-cell',parentLabel: '成本支付(司机代支部分)'},
          {label: '代支高速费',prop: 'highFee',check: true,fixed: undefined,formatter: 'getNumValue',styleClass: 'yellow-cell',parentLabel: '成本支付(司机代支部分)'},
          {label: '代支打印费',prop: 'printFee',check: true,fixed: undefined,formatter: 'getNumValue',styleClass: 'yellow-cell',parentLabel: '成本支付(司机代支部分)'},
          {label: '代支维修费',prop: 'maintainFee',check: true,fixed: undefined,formatter: 'getNumValue',styleClass: 'yellow-cell',parentLabel: '成本支付(司机代支部分)'},
          {label: '代支其他费用',prop: 'otherFee',check: true,fixed: undefined,formatter: 'getNumValue',styleClass: 'yellow-cell',parentLabel: '成本支付(司机代支部分)'},
          {label: '代支现金加油费',prop: 'refuelFee',check: true,fixed: undefined,formatter: 'getNumValue',styleClass: 'yellow-cell',parentLabel: '成本支付(司机代支部分)'},
          {label: '代支现金过路费',prop: 'passingFee',check: true,fixed: undefined,formatter: 'getNumValue',styleClass: 'yellow-cell',parentLabel: '成本支付(司机代支部分)'},
          {label: '司机月代垫',prop: 'driverPrepayment',check: true,fixed: undefined,formatter: 'getNumValue'},
          {label: '司机借支',prop: 'driverBorrowing',check: true,fixed: undefined,formatter: 'getNumValue'},
          {label: '未付款',prop: 'payableAmount',check: true,fixed: undefined,formatter: 'getNumValue'},
        ],
        configDefaultPropColumn: [],
        configDefaultColumnTwo: [],
        isConfigMode: false,
        configModeForm: {
          name: '',
          remark: '',
          defaultOrNot: '0'
        },
        configDefaultPropColumnMap: new Map(),
      },
      // -----------------动态表格模式end-----------------


      // 域名
      domain: '',
      pushTheMonthlySalarySlipDisabled: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今月',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '上月',
          onClick(picker) {
            const now = new Date();
            const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', start);
          }
        }, {
          text: '前月',
          onClick(picker) {
            const now = new Date();
            const start = new Date(now.getFullYear(), now.getMonth() - 2, 1);
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', start);
          }
        }]
      },
      dataForm: {
        driverName: null,
        takeGoodsDate: null,
        pushNotification: null,
        confirmStatus: null,
      },
      showTotal: false,
      dataList: [],
      pageIndex: 1,
      getIndex: -1,
      pageSize: 20,
      tableHeight: '65vh',
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      detailVisible: false,
      reject: {
        rejectRow: null,
        visible: false,
        title: '',
        data: {},
      }

    }
  },
  created () {
    this.initConfigTable()

    this.$http({
      url: this.$http.adornUrl('/sys/appConfig/get'),
      method: 'get',
      params: this.$http.adornParams({ type: 2 })
    }).then(({ data }) => {
      this.domain = JSON.parse(data.configValue).spaceDomain
    })
    let now = new Date()
    this.dataForm.takeGoodsDate = this.dateFormatter(now, 'yyyy-MM')
    this.getDataList()
  },
  computed: {
    dictTypeMap: {
      get () { return this.$store.state.common.dictTypeMap }
    },
    mainTabs: {
      get () {
        return this.$store.state.common.mainTabs
      },
      set (val) {
        this.$store.commit('common/updateMainTabs', val)
      }
    },
  },
  methods: {
    // -----------------动态表格模式start-----------------
    initConfigTable() {
      this.$http({
        url: this.$http.adornUrl('/tabulation/default/' + this.config.configTableId),
        method: 'get',
        params: this.$http.adornParams()
      }).then(async ({ data }) => {
        if (data) {
          this.config.configModeForm.name = data.name
          this.config.configModeForm.remark = data.remark
          this.config.configModeForm.defaultOrNot = data.defaultOrNot
          this.config.configId = data.id
          if (data.tmsTabulationConfigValueList && data.tmsTabulationConfigValueList.length > 0) {
            this.assignPropertiesLarge(this.config.configDefaultColumn, data.tmsTabulationConfigValueList,'prop',['label','fixed','width'])
            this.config.configDefaultColumn = this.reorderArray(this.config.configDefaultColumn, data.tmsTabulationConfigValueList, 'prop');
          }
        }
        this.config.configDefaultColumn.forEach(x => {
          this.config.configDefaultPropColumn.push({prop: x.prop})
          this.config.configDefaultPropColumnMap.set(x.prop,x)
        })


        // 修正数据
        this.processedColumns(this.config.configDefaultColumn)
      })

    },
    assignPropertiesLarge (arr1, arr2, compareProp, assignProps) {
      const map = new Map();
      arr2.forEach(item => {
        map.set(item[compareProp], item);
      });
      arr1.forEach(item => {
        const match = map.get(item[compareProp]);
        if (match) {
          assignProps.forEach(prop => {
            item[prop] = match[prop];
          });
          item.check = true
        } else {
          item.check = false
        }
      });
      return arr1;
    },
    reorderArray(arr1, arr2, key) {
      if (arr2.length === 0) {
        return arr1;
      }

      // 存储第二个数组中元素的特定属性值
      const targetValues = arr2.map(item => item[key]);
      // 存储匹配的元素
      const matched = [];
      // 存储未匹配的元素
      const unmatched = [];

      // 遍历第一个数组，将匹配的元素和未匹配的元素分别存储
      for (const item of arr1) {
        if (targetValues.includes(item[key])) {
          matched.push(item);
        } else {
          unmatched.push(item);
        }
      }

      // 对匹配的元素进行排序，使其顺序与第二个数组一致
      const sortedMatched = targetValues.map(value => {
        return matched.find(item => item[key] == value);
      }).filter(item => item!== undefined);
      // 合并匹配的元素和未匹配的元素
      return [...sortedMatched, ...unmatched];
    },
    templateConfigurationMode(type) {
      // 开启配置模式
      if (type === 0) {
        this.config.isConfigMode = true
        this.$nextTick(() => {
          const tree = this.$refs.configTableListTree;
          this.config.configDefaultColumn.forEach((node) => {
            if (node.check) {
              tree.setChecked(node.prop, true);
            }
          });
        })
      }
      // 保存/修改配置模式
      else if (type === 1 || type === 2) {
        // 检测
        if (!this.config.configModeForm.name) {
          this.$message.error('请输入配置模板名称!');
          return
        }
        if (type === 2) {

          if (!this.config.configId) {
            this.$message.error('未检测出有配置相关模板并启用,请新增!');
            return
          }
        }
        this.$nextTick(() => {
          let submitTable = myJsonClon.getClone(this.config.configModeForm)
          submitTable.tableId = this.config.configTableId
          submitTable.id = type === 2 ? this.config.configId : undefined
          const tableRef = this.$refs.tableRef;
          let tmsTabulationConfigValueList = []
          tableRef.columns.forEach((x,index) => {
            if (x.type != 'index' || x.type != 'selection') {
              tmsTabulationConfigValueList.push({label: x.label,prop: x.property,fixed: x.fixed,width: x.width,sort: index})
            }
          })
          submitTable.tmsTabulationConfigValueList = tmsTabulationConfigValueList;
          this.$http({
            url: this.$http.adornUrl(type === 1 ? '/tabulation/add' : '/tabulation/update'),
            method: type === 1 ? 'post' : 'put',
            data: submitTable
          }).then(async ({ data }) => {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
            })
            window.location.reload()
          })
        })
      }
    },
    getFormatter(formatterName) {
      if (formatterName) {
        // 首先尝试从组件的 methods 中获取方法
        let method = this[formatterName];
        if (typeof method === 'function') {
          return method;
        }
        // 若组件的 methods 中没有，再尝试从 Vue.prototype 中获取方法
        method = Vue.prototype[formatterName];
        if (typeof method === 'function') {
          return method;
        }
      }
      // 若都没找到，返回一个直接返回原始值的函数
      return (row, column, cellValue) => cellValue;
    },
    checkAllNodes (isChecked) {
      this.$nextTick(() => {
        if (isChecked) {
          this.$refs.configTableListTree.setCheckedNodes(this.config.configDefaultPropColumn)
        } else {
          this.$refs.configTableListTree.setCheckedKeys([])
          this.$forceUpdate()
        }
      })
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      const tree = this.$refs.configTableListTree;
      tree.setChecked(draggingNode.data.prop, draggingNode.data.check);

      // 强制刷新表格
      this.refreshTableV(this.config.configDefaultColumn)
    },
    handleCheckChange(data, checked, indeterminate) {
      const targetElement = this.config.configDefaultColumn.find(item => item.prop === data.prop);
      targetElement.check = checked

      // 强制刷新表格
      this.refreshTableV(this.config.configDefaultColumn)
    },
    allowDrag(draggingNode) {
      return draggingNode.data.fixed ? false : true
    },
    allowDrop(draggingNode, dropNode, type) {
      return type === 'inner' ? false : true
    },
    getCellClassName({ row, column, rowIndex, columnIndex }) {
      let newVar = this.config.configDefaultPropColumnMap.get(column.property);
      if (newVar && newVar.styleClass) {
        return newVar.styleClass;
      }
      return '';
    },
    refreshTableV(configDefaultColumn) {
      this.processedColumns(configDefaultColumn)
      //this.$nextTick(async () => {
      //setTimeout(() => {
      //  this.$refs.tableRef.doLayout()
      //}, 2000)
      //});
    },
    processedColumns(configDefaultColumn) {
      let source = myJsonClon.getClone(configDefaultColumn);

      const result = [];
      const groupMap = new Map();
      const groupFirstIndex = {};
      const insertedGroups = new Set();

      // 1. 收集所有分组信息
      source.forEach((item, index) => {
        if (item.parentLabel) {
          if (!groupFirstIndex[item.parentLabel]) {
            groupFirstIndex[item.parentLabel] = index;
          }
          if (!groupMap.has(item.parentLabel)) {
            groupMap.set(item.parentLabel, {
              label: item.parentLabel,
              styleClass: item.styleClass,
              children: []
            });
          }
          groupMap.get(item.parentLabel).children.push(item);
        }
      });

      // 2. 构建最终列数组
      let i = 0;
      while (i < source.length) {
        const item = source[i];

        if (!item.parentLabel) {
          // 独立列直接添加
          result.push(item);
          i++;
        } else {
          const groupName = item.parentLabel;

          if (!insertedGroups.has(groupName)) {
            // 插入分组对象
            const group = groupMap.get(groupName);
            result.push(group);
            insertedGroups.add(groupName);

            // 标记这些子项为已处理
            group.children.forEach(child => {
              child._processed = true;
            });
          }

          // 无论是否新分组，都前进到下一项
          i++;
        }
      }

      // 3. 确保所有原始列都被包含（处理拖动后顺序变化的情况）
      const finalResult = [];
      const usedGroups = new Set();

      source.forEach(item => {
        if (!item.parentLabel) {
          finalResult.push(item);
        } else {
          const groupName = item.parentLabel;
          if (!usedGroups.has(groupName)) {
            const group = groupMap.get(groupName);
            finalResult.push(group);
            usedGroups.add(groupName);
          }
        }
      });


      this.config.configDefaultColumnTwo = finalResult
      this.$nextTick(() => {
        this.$refs.tableRef?.doLayout();
        this.config.tableKey++;
      });

    },
    // -----------------动态表格模式end-----------------

    /**
     * 点击表格变色start
     */
    selectedHighlight ({ row, rowIndex }) {
      if ((this.getIndex) === rowIndex ) {
        return {
          'background-color': 'rgb(250, 195, 100)'
        }
      }
    },
    // 如果为已取消时，该行置灰
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex
      if (row.status === 12) {
        return 'cancel-row'
      }
      return ''
    },
    rowClick (row) {
      this.getIndex = row.index
    },
    // 获取数据列表
    getDataList (pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex;
      }
      this.dataListLoading = true
      let takeGoodsTime = this.dataForm.takeGoodsDate
      let timeParam = {}
      if (takeGoodsTime) {
        timeParam.takeGoodsBeginDate = takeGoodsTime
        timeParam.takeGoodsEndDate = takeGoodsTime
      }
      this.$http({
        url: this.$http.adornUrl('/costSummary/driverPrepaymentList'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'driverName': this.dataForm.driverName,
          'beginDate': timeParam.takeGoodsBeginDate,
          'endDate': timeParam.takeGoodsEndDate,
          'takeGoodsDate': takeGoodsTime,
          'pushNotification': this.dataForm.pushNotification,
          'confirmStatus': this.dataForm.confirmStatus,
        })
      }).then(({ data }) => {
        if (data && data.list.length > 0) {
          this.dataList = data.list
          this.totalPage = data.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        if (!this.showTotal) {
          // 解决elementUI table合计行初始页面不显示问题  this.height由父组件传递过来 this.theight未表格绑定的高度
          this.tableHeight = '67vh'
          this.showTotal = true
        }
        this.dataListLoading = false
      })
    },
    downLoad () {
      let takeGoodsTime = this.dataForm.takeGoodsDate
      let timeParam = {}
      if (takeGoodsTime) {
        timeParam.takeGoodsBeginDate = takeGoodsTime
        timeParam.takeGoodsEndDate = takeGoodsTime
      }
      this.$http({
        url: this.$http.adornUrl(`/costSummary/export/driverPrepaymentList`),
        method: 'get',
        responseType: 'blob',
        params: this.$http.adornParams({
          'driverName': this.dataForm.driverName,
          'beginDate': timeParam.takeGoodsBeginDate,
          'endDate': timeParam.takeGoodsEndDate,
          'takeGoodsDate': takeGoodsTime,
          'pushNotification': this.dataForm.pushNotification,
          'confirmStatus': this.dataForm.confirmStatus,
        })
      }).then(({ data }) => {
        const blob = data
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = '司机代垫统计表.xls'
          a.href = e.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      })
    },
    getNumValue (row, cell, value) {
      return this.getValue(value)
    },
    getValue (value) {
      if (value === undefined || value === null) {
        return ''
      }
      if (value === 0) {
        return ''
      } else {
        return value
      }
    },
    getAllSummaries (profitCount) {
      // 合计参数，按顺序返回
      let param = ['合计', '', '',
        this.getValue(profitCount.vehicleProfitMonth),
        this.getValue(profitCount.freightFee),
        this.getValue(profitCount.payFreightFee),
        this.getValue(profitCount.refuelFee),
        this.getValue(profitCount.passingFee),
        this.getValue(profitCount.stayFee),
        this.getValue(profitCount.extraFee),
        this.getValue(profitCount.royaltyFee),
        this.getValue(profitCount.salesmanFee),
        this.getValue(profitCount.salesmanManagerFee),
        this.getValue(profitCount.serviceFee),
        this.getValue(profitCount.maintainFee),
        this.getValue(profitCount.taxesFee),
        this.getValue(profitCount.createCardFee),
        this.getValue(profitCount.insureMoney),
        this.getValue(profitCount.repairMoney),
        this.getValue(profitCount.lossMoney)
      ]
      // 创建列表行
      let tr = document.createElement('tr')
      // 删除上一条合计
      if (document.querySelector('.el-table__footer-wrapper table tbody').childElementCount === 2) {
        document.querySelector('.el-table__footer-wrapper table tbody').lastChild.remove()
      }
      // td赋值
      param.forEach((item, index) => {
        let td = document.createElement('td')
        td.innerHTML = item
        tr.appendChild(td)
      })
      // 添加合计
      document.querySelector('.el-table__footer-wrapper table tbody').appendChild(tr)
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },

    // 推送
    pushTheMonthlySalarySlip() {
      try {
        this.pushTheMonthlySalarySlipDisabled = true
        if (!this.dataForm.takeGoodsDate) {
          this.$message.error('请选择月份')
          return
        }
        if (this.dataListSelections.length == 0) {
          this.$message.error('请选择数据')
          return
        }
        this.$http({
          url: this.$http.adornUrl('/costSummary/pushPaySlip/' + this.dataForm.takeGoodsDate + '/1'),
          method: 'post',
          data: { ids: this.dataListSelections.map(item => item.id) }
        }).then(({data}) => {
          if (data) {
            this.$message.success('推送成功')
            this.getDataList();
          } else {
            this.$message.error('推送失败,检查是否已推送,无需重复推送')
          }
        })
      } finally {
        this.pushTheMonthlySalarySlipDisabled = false
      }
    },

    // 表格选中
    handleSelectionChange (val) {
      this.dataListSelections = val
    },

    // 调整
    smallProgramPageConfiguration() {
      this.mainTabs = this.mainTabs.filter(item => item.name !== 'statisticalReport-driverPrepaymentSummary')

      setTimeout(() => {
        this.$router.push({
          name: "page-page",
          params: { key: 'statisticalReport-driverPrepaymentSummary',no: 1, sourceType: 1},
        });
      },300)

    },

    // 驳回
    rejectMethod(row) {
      // 重置
      this.reject = this.$options.data().reject

      // 处理
      this.reject.rejectRow = row
      this.reject.title = '驳回: (' + row.driverName + ') 确认信息'
      this.reject.visible = true
    },
    rejectSuccess() {
      try {
        if (!this.reject.data.remark) {
          this.$message.error('请输入驳回原因')
          return
        }
        this.$http({
          url: this.$http.adornUrl(`/costSummary/rejectPaySlip`),
          method: 'get',
          params: this.$http.adornParams({ remark: this.reject.data.remark,id: this.reject.rejectRow.pushId })
        }).then(({data}) => {
          if (data) {
            this.$message.success('驳回成功')
            this.reject.visible = false
            this.getDataList();
          } else {
            this.$message.error('驳回失败,必须已确认信息才允许驳回')
          }
        })
      } finally {
        this.pushTheMonthlySalarySlipDisabled = false
      }
    }
  }
}
</script>
<style lang="less">
  span.searchUpload {
    display: inline-block;
    margin-left: 10px;
  }
</style>
